export default __webpack_public_path__ + "static/media/pink_monster.52070d03.gif";